import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useLanguageDirection from "../hooks/useLanguageDirection";

const NotFoundPage = () => {
  const { t } = useTranslation();
  const direction = useLanguageDirection();
  return (
    <div
      className="flex items-center justify-center min-h-screen bg-yellow-50"
      dir={direction}
    >
      <div className="px-4 text-center">
        <div className="mb-8">
          <h1 className="mb-4 font-bold text-9xl text-custom-yellow">404</h1>
          <div className="w-24 h-1 mx-auto mb-8 bg-black"></div>
        </div>

        <div className="mb-8">
          <h2 className="mb-4 text-3xl font-semibold text-gray-800">
            {t("page_not_found") || "Page Not Found"}
          </h2>
          <p className="max-w-md mx-auto text-lg text-gray-600">
            {t("page_not_found_description") ||
              "The page you are looking for might have been removed, had its name changed, or is temporarily unavailable."}
          </p>
        </div>

        <div className="flex flex-col justify-center gap-4 sm:flex-row">
          <Link
            to="/"
            className="z-0 inline-flex items-center justify-center px-4 py-2 text-base text-black transition duration-500 ease-in-out transform bg-custom-yellow rounded-custom hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color whitespace-nowrap"
          >
            <svg
              className="w-5 h-5 me-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
              />
            </svg>
            {t("go_home") || "Go Home"}
          </Link>

          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center justify-center px-4 py-2 text-base text-white transition duration-500 ease-in-out transform bg-black border border-white rounded-custom hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color whitespace-nowrap"
          >
            {t("go_back") || "Go Back"}
            <svg
              className={`w-5 h-5 ms-2 ${direction === "ltr" && "rotate-180"}`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M10 19l-7-7m0 0l7-7m-7 7h18"
              />
            </svg>
          </button>
        </div>

        <div className="mt-12">
          <div className="text-sm text-gray-500">
            {t("need_help") || "Need help?"}{" "}
            <Link
              to="/contact-us"
              className="underline duration-300 text-custom-yellow hover:text-black"
            >
              {t("contact_us") || "Contact us"}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
